import { render, staticRenderFns } from "./CustomFieldModalUpdateViewExtendedData.vue?vue&type=template&id=0eb33548&scoped=true"
import script from "./CustomFieldModalUpdateViewExtendedData.vue?vue&type=script&lang=ts"
export * from "./CustomFieldModalUpdateViewExtendedData.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldModalUpdateViewExtendedData.vue?vue&type=style&index=0&id=0eb33548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb33548",
  null
  
)

export default component.exports